import { createAction, props } from '@ngrx/store';
import { CodeSetResponse } from '../codeset/codeset.model';

import { ServiceError } from '@cigna/chcp/shared/util';

export const loadCodeSet = createAction('[Codeset] Fetch Codeset');
export const loadCodeSetSuccess = createAction(
  '[Codeset] Fetch Codeset Success',
  props<{
    payload: CodeSetResponse;
  }>(),
);
export const loadCodeSetError = createAction(
  '[Codeset] Fetch Codeset Error',
  props<{ error: ServiceError }>(),
);
